module.exports = __webpack_public_path__ + "static/media/onboarding-push-image.c570286f.gif";